module.exports = __webpack_public_path__ + "static/media/litho-5.be91a81a.jpg";